import React from 'react';
import cx from 'classnames';
import { Text, Select, HeaderSection } from '@groupelacentrale/contact-storybook';
import { FormikErrors, FormikTouched } from 'formik';
import { VehicleType, VehicleVersionBodyFields, VehicleVersionBodyFieldsList } from 'types';

interface Props {
  vehicleType: VehicleType;
  vehicleVersionBodyFieldsList: VehicleVersionBodyFieldsList;
  refs?: Record<keyof VehicleVersionBodyFieldsList, React.RefObject<HTMLDivElement>>;
  updatedFields?: Record<keyof VehicleVersionBodyFieldsList, boolean>;
  values: VehicleVersionBodyFields;
  touched: FormikTouched<VehicleVersionBodyFields>;
  errors: FormikErrors<VehicleVersionBodyFields>;
  handleBlur: (e: React.FocusEvent<unknown>) => void;
  handleChange: (e: React.ChangeEvent<unknown>) => void;
}

export const VehicleBodyFormView: React.FC<Props> = ({
  vehicleType,
  values,
  vehicleVersionBodyFieldsList,
  refs,
  updatedFields,
  touched,
  errors,
  handleBlur,
  handleChange,
}) => {
  return (
    <div className="vehicle-version-body-fields">
      <HeaderSection noUnderline>{vehicleType === 'MOTO' ? 'Carroserie' : 'Carrosserie et intérieur'}</HeaderSection>
      <div className="field-wrapper version-list" ref={refs?.externalColor}>
        <Text className={cx('field-label', { 'updated-field': updatedFields?.externalColor })}>
          Couleur extérieure*
        </Text>
        <Select
          name="externalColor"
          defaultValue={values.externalColor}
          options={[{ label: 'Choisissez', value: '' }, ...vehicleVersionBodyFieldsList.externalColor]}
          onBlur={handleBlur}
          onChange={handleChange}
          errorMessage={touched.externalColor ? errors.externalColor : undefined}
        />
      </div>
      <div className="field-wrapper version-list" ref={refs?.paintType}>
        <Text className={cx('field-label', { 'updated-field': updatedFields?.paintType })}>Type de peinture*</Text>
        <Select
          name="paintType"
          defaultValue={values.paintType}
          options={[{ label: 'Choisissez', value: '' }, ...vehicleVersionBodyFieldsList.paintType]}
          onBlur={handleBlur}
          onChange={handleChange}
          errorMessage={touched.paintType ? errors.paintType : undefined}
        />
      </div>
      {vehicleType !== 'MOTO' && (
        <>
          <div className="field-wrapper version-list" ref={refs?.internalColor}>
            <Text className={cx('field-label', { 'updated-field': updatedFields?.internalColor })}>
              Couleur intérieure*
            </Text>
            <Select
              name="internalColor"
              defaultValue={values.internalColor}
              options={[{ label: 'Choisissez', value: '' }, ...vehicleVersionBodyFieldsList.internalColor]}
              onBlur={handleBlur}
              onChange={handleChange}
              errorMessage={touched.internalColor ? errors.internalColor : undefined}
            />
          </div>
          <div className="field-wrapper version-list" ref={refs?.seatMaterial}>
            <Text className={cx('field-label', { 'updated-field': updatedFields?.seatMaterial })}>
              Matière des sièges*
            </Text>
            <Select
              name="seatMaterial"
              defaultValue={values.seatMaterial}
              options={[{ label: 'Choisissez', value: '' }, ...vehicleVersionBodyFieldsList.seatMaterial]}
              onBlur={handleBlur}
              onChange={handleChange}
              errorMessage={touched.seatMaterial ? errors.seatMaterial : undefined}
            />
          </div>
        </>
      )}
    </div>
  );
};
